import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { listCardsDataQueryKey } from 'api/queries/getListFilteredCards.query';
import { queryKey as runSimulationQueryKey } from 'api/queries/getSchedulingSimulationResults.query';

import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { Pills } from 'components/common/pills/pills';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { TreeProgramTopHeader } from 'components/common';
import { SimulationSteps } from 'components/widgets/ScheduleSimulation/SimulationMain/SimulationSteps';

export const ScheduleSimulation = () => {
    useFullStoryPageView({ pageName: riskConfig.scheduleSimulation.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader />
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader
                        pageTitle={riskConfig.scheduleSimulation.title}
                        endComponent={<Pills>BETA</Pills>}
                    />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <SimulationSteps />
            </MainContent>
            <MainCardRoutingModal queryKeys={[runSimulationQueryKey, listCardsDataQueryKey]} />
        </PageContainer>
    );
};
